// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { MessageProcessorBase } from './MessageProcessorBase';
import { SubscriptionStrategyRequestMessage } from '../Messages/SubscriptionStrategyRequestMessage';
export class SubscriptionStrategyRequestMessageProccesor extends MessageProcessorBase {
    decode(fieldSet) {
        const message = new SubscriptionStrategyRequestMessage(fieldSet);
        return [message];
    }
}
